var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d54098ab63937f23b9f87b5c04fe862e5fbb23af"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"d54098ab63937f23b9f87b5c04fe862e5fbb23af"};
      